module.exports = __webpack_public_path__ + "img/5.8beb0ecd.png";